<template>
  <div v-if="isLoading">
    <LoadingPlaceholder/>
  </div>
  <div v-else>
    <Breadcrumbs
      :breadcrumbs="[
     {title: this.$t(`menu.${serviceSlug}`), disabled: true},
     {title: this.$t('menu.leads-web/flows'), active: true, meta: {type: 'string', value: `/${this.leadsWebService.slug}/${this.leadsWebService.slug}/flows`}},
     {title: flow.name, disabled: true}
   ]"/>

    <div>
      <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3"> {{isUpdating ? $t('leads-web.actions.update_flow', {name: flow.name}) : $t('leads-web.actions.flow_details', {name: flow.name})}} </h5>

      <FlowDetails
        v-model="flowForm"
        :entities="entities"
        :countries="countries"
        :langOptions="langOptions"
        :isUpdating="isUpdating"
      />

      <ContactActionsTable v-if="contactActions.length > 0"
        v-model="contactActions"
      />
    </div>



    <!-- Buttons row -->
    <div class="row d-flex justify--space-between mt-3 ml-3 mr-3">
      <va-button class="btn-cancel" @click="handleCancel">
        {{isUpdating ? $t('iframe.actions.cancel') : $t('modals.buttons.back')}}
      </va-button>

      <!--<va-button @click="handleSave">
        {{$t('iframe.actions.save')}}
      </va-button>-->
    </div>
    <!-- --- --- --- -->
  </div>
</template>

<script>
import Breadcrumbs from "@/components/common/Breadcrumbs";
import LoadingPlaceholder from "@/components/common/LoadingPlaceholder";
import {mapState} from "vuex";
import {LeadsWebService} from "@/api/LeadsWebService";
import FlowDetails from "@/components/leads-web/flows/FlowDetails";
import * as countries from "i18n-iso-countries";
import Vue from "vue";
import ContactActionsTable from "@/components/leads-web/flows/ContactActionsTable";

export default {
  components: {ContactActionsTable, FlowDetails, LoadingPlaceholder, Breadcrumbs},
  props: {
    serviceSlug: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      isLoading: true,
      isUpdating: false,
      flowForm:{
        name: null,
        client_id: null,
        client: null,
        lang: null,
        country: null,
        start_date: null,
        end_date: null
      },
      flow: null,
      contactActions: []
    }
  },
  async mounted() {
    try {
      this.flow = await LeadsWebService.getFlowById(this.$route.params.id)
      this.contactActions = await LeadsWebService.getContactActions(this.flow.id, true)
      this.isLoading = false
      this.prefillForm()
    } catch (err) {
      //todo handle err
      console.log(err)
    }
  },
  methods:{
    prefillForm: function() {
      this.flowForm = {...this.flow}
      this.flowForm.start_date = this.moment(this.flowForm.start_date).format('YYYY-MM-DD HH:ss')
      this.flowForm.end_date = this.moment(this.flowForm.end_date).format('YYYY-MM-DD HH:ss')
      this.flowForm.client = this.entities.filter(ent => ent.id === this.flow.client_id)[0] || null
      this.flowForm.lang = this.langOptions.filter(item => item.lang.toUpperCase() === this.flowForm.lang.toUpperCase())
      this.flowForm.country = this.countries.filter(item => item.code.toUpperCase() === this.flowForm.country.toUpperCase())
    },
    handleCancel: function() {
      this.$router.push({path:`/${this.leadsWebService.slug}/${this.leadsWebService.slug}/flows`})
    },
    handleSave: function() {
      //todo
    }

  },
  computed: {
    ...mapState({
      'leadsWebToken': (state) => state.leadsWeb.leadsWebSrvToken,
      'langOptions': (state) => state.languages
    }),
    leadsWebService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.leads_web_server) || null
    },
    entities: function () {
      if (this.leadsWebService) {
        return this.leadsWebService.entities
      }
      return []
    },
    /*countries: function () {
      for (let code of this.$store.state.countries.allowed) {
        if (code.toLowerCase() === "gb") {
          code = "en"
        }
        countries.registerLocale(require(`i18n-iso-countries/langs/${code.toLowerCase()}.json`))
      }
      let tempCountries = countries.getNames(Vue.i18n.locale().toLowerCase() === 'gb' ? 'en' : Vue.i18n.locale().toLowerCase())
      let countriesList = []
      for(const key in tempCountries) {
        countriesList.push({
          name: tempCountries[key],
          code: key
        })
      }
      return countriesList
    },*/
    countries: function () {
      for (let code of this.$store.state.countries.allowed) {
        if (code.toLowerCase() === "gb") {
          code = "en"
        } else if (code.toLowerCase() === 'cz') {
          code = 'cs'
        }
        countries.registerLocale(require(`i18n-iso-countries/langs/${code.toLowerCase()}.json`))
      }
      let vueI18nLocale = Vue.i18n.locale().toLowerCase()
      switch (vueI18nLocale) {
        case 'gb':
          vueI18nLocale = 'en'
          break;
        case 'cz':
          vueI18nLocale = 'cs'
          break;
      }
      let tempCountries = countries.getNames(vueI18nLocale)
      let countriesList = []
      for(const key in tempCountries) {
        countriesList.push({
          name: tempCountries[key],
          code: key
        })
      }
      return countriesList
      //return CountryList.filter(country => this.$store.state.countries.allowed.includes(country.code))
      //return CountryList
    },
  }
}
</script>

<style scoped>

</style>
